import React, { useState, useEffect, useRef, useLayoutEffect } from "react";

import Button from "react-bootstrap/Button";
import "./SlidePreview.css";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Stack from "react-bootstrap/Stack";
import axios from "axios";
import { marked } from "marked";
import Spinner from "react-bootstrap/Spinner";
import Card from "react-bootstrap/Card";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import Form from "react-bootstrap/Form";
import { faGrip } from "@fortawesome/free-solid-svg-icons";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  TimeScale,
  ScatterController,
} from "chart.js";
import "./CustomComponent.css";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  TimeScale,
  ScatterController,
  Title,
  Tooltip,
  Legend
);
import { Pie, Bar, Line, Scatter } from "react-chartjs-2";

export const SlidePreview = (props) => {
  const [isProcessing, setIsProcessing] = useState(false);
  // const onTextChange = (event) => setTextValue(event.target.value);
  const [textValue, setTextValue] = useState(props.slide.prompt);
  const [promptTitle, setPromptTitle] = useState(props.slide.title);

  useEffect(() => {
    if (promptTitle != props.slide.title) {
      const delaySearch = setTimeout(() => {
        axios
          .post(
            process.env.REACT_APP_API_DOMAIN + "/editSubTopicTitle",
            {
              subTopicId: props.slide.id,
              editedTitle: promptTitle,
            },
            {
              headers: {
                authorization: `Bearer ${localStorage.getItem("token")}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            props.slide.title = promptTitle;
          })
          .catch((error) => {
            console.log(error);
          });
      }, 1000);

      return () => clearTimeout(delaySearch);
    }
  }, [promptTitle]);

  function onTitleChange(event) {
    setPromptTitle(event.target.value);
  }

  useEffect(() => {
    if (textValue != props.slide.prompt) {
      const delaySearch = setTimeout(() => {
        axios
          .post(
            process.env.REACT_APP_API_DOMAIN + "/editSubTopic",
            {
              subTopicId: props.slide.id,
              editedPrompt: textValue,
            },
            {
              headers: {
                authorization: `Bearer ${localStorage.getItem("token")}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            props.slide.prompt = textValue;
          })
          .catch((error) => {
            console.log(error);
          });
      }, 1000);

      return () => clearTimeout(delaySearch);
    }
  }, [textValue]);

  function onTextChange(event) {
    setTextValue(event.target.value);
  }

  const textareaRef = useRef(null);

  useLayoutEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "inherit";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [textValue, promptTitle]);

  function deleteCard() {
    setIsProcessing(true);

    axios
      .post(
        process.env.REACT_APP_API_DOMAIN + "/deleteSubTopic",
        {
          subTopicId: props.slide.id,
          reportId: props.slide.topic_id,
        },
        {
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        props.setSlides(response.data.subtopics);
        setIsProcessing(false);
        props.setRadioNumPagesName(
          response.data.report.slide_numbers.toString() + " Slides"
        );
        props.setNumPages(
          response.data.report.slide_numbers.toString() + " Slides"
        );
      })
      .catch((error) => {
        console.log(error);
      });
  }
  return (
    <div>
      <div className="previewSlideContainer">
        <div className="slidePreviewCard">
          {" "}
          <Stack direction="horizontal">
            <div className="slidePreviewNumber">
              {" "}
              {props.index + 1}
              <br></br>{" "}
              <FontAwesomeIcon icon={faGrip} color="lightGray" size="sm" />
            </div>
            <Stack direction="vertical">
              <div className="slidePreviewTitle">
                <Form.Control
                  as="textarea"
                  ref={textareaRef}
                  onChange={onTitleChange}
                  placeholder="Add your title"
                  value={promptTitle}
                  rows={1}
                  className="slidePreviewTitleEdit"
                />
                {props.slidesLength > 1 ? (
                  <div className="delete_card">
                    <Button
                      onClick={deleteCard}
                      variant="link"
                      className="deleteButton"
                    >
                      <FontAwesomeIcon
                        icon={faTrash}
                        color="lightGray"
                        size="sm"
                      />
                    </Button>
                  </div>
                ) : (
                  <div className="delete_card"></div>
                )}
              </div>
              {isProcessing ? (
                <div className="pendingDelete">
                  <Spinner animation="border" variant="primary" />
                </div>
              ) : (
                <div className="slidePreviewContent">
                  <Form.Control
                    as="textarea"
                    ref={textareaRef}
                    placeholder="Add your prompt"
                    onChange={onTextChange}
                    value={textValue}
                    className="slidePreviewForm"
                  />
                </div>
              )}
            </Stack>
          </Stack>
        </div>
      </div>
    </div>
  );
};

export default SlidePreview;
